// Angular
import {
  Component,
  Input,
  Output,
  EventEmitter,
  inject,
  ChangeDetectionStrategy,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser, NgOptimizedImage } from '@angular/common';
// PrimeNG
import { CarouselModule } from 'primeng/carousel';
import { Slide } from '@core/models-v2/cms/slider-reponse.interface';
import { HeroCarouselStateService } from '../../services/hero-carousel-state.service';

const NG_MODULES = [NgOptimizedImage];
const PRIME_MODULES = [CarouselModule];

@Component({
  selector: 'app-hero-carousel-interactive',
  standalone: true,
  imports: [NG_MODULES, PRIME_MODULES],
  templateUrl: './hero-carousel-interactive.component.html',
  styleUrl: './hero-carousel-interactive.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroCarouselInteractiveComponent {
  readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  @Input({ required: true }) slides!: Slide[];
  @Output() slideClick = new EventEmitter<{
    slide: Slide;
    index: number;
    originalEvent: Event;
  }>();

  readonly stateService = inject(HeroCarouselStateService);

  get config() {
    return this.stateService.config;
  }

  onSlideClick(slide: Slide, index: number, event: Event): void {
    this.slideClick.emit({ slide, index, originalEvent: event });
  }
}
